var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-1094.000000, -183.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(1095.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,10.4782609 L12,23",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "7.82608696 18.826087 12 23 16.173913 18.826087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.173913,16.6956522 C17.173913,16.6956522 18.7826087,16.6956522 18.7826087,16.6956522 C21.6521739,16.6956522 24,14.3478261 24,11.4782609 C24,8.60869565 21.6521739,6.26086957 18.7826087,6.26086957 C18.4695652,2.76521739 15.5478261,0 12,0 C8.24347826,0 5.2173913,3.02608696 5.2173913,6.7826087 L5.2173913,7.82608696 C5.2173913,7.82608696 4.43478261,7.82608696 4.43478261,7.82608696 C2.08695652,7.82608696 0.156521739,9.65217391 0,12 L0,16.6956522 L6.82608696,16.6956522",
    id: "Stroke-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/Icon_Download.a9a31b9acd769507302f5353956042da.svg";
export { ForwardRef as ReactComponent };